import { Activity } from "@mapmycustomers/shared/types/entity";

// Per-record access gates editing; fall back to the global permission when accessStatus is absent,
// so an activity fetched without access flags stays editable for anyone whose role allows it.
const canUpdateActivity = (activity: Activity, hasEditPermission: boolean): boolean =>
  activity.accessStatus?.update ?? hasEditPermission;

export default canUpdateActivity;
